import React, { useMemo } from 'react'
import { Bar } from 'react-chartjs-2'
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

import { StatsData } from './RevampedFaberCustomerDashboard'

function StatsChart({ chartTitle, chartData }: ChartProps) {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
  )

  const generateOptions = () => {
    return {
      indexAxis: 'y' as const,
      elements: {
        bar: {
          borderWidth: 2,
          datalabels: {
            align: 'end',
            anchor: 'end',
            color: 'black',
            font: {
              weight: 'bold'
            }
          }
        }
      },
      scales: {
        x: {
          grid: {
            display: true
          }
        },
        y: {
          grid: {
            display: false
          }
        }
      },

      responsive: true,
      plugins: {
        datalabels: {
          align: 'end' as const,
          anchor: 'end' as const,
          color: 'black' as const,
          font: {
            weight: 'bold'
          } as const,
          offset: 4 // Adjust the offset to move the labels further from the bars
        },
        legend: {
          display: false,
          position: 'right' as const
        },
        title: {
          display: true,
          text: chartTitle
        }
      }
    }
  }

  const options = useMemo(() => {
    return generateOptions()
  }, [chartTitle])

  return <Bar options={options} plugins={[ChartDataLabels]} data={chartData} />
}

export default StatsChart

interface ChartProps {
  chartTitle: string
  chartData: StatsData
}
